import React, { forwardRef } from 'react';
import { ButtonV2 } from '@groupby/ui-components';
export const Button = forwardRef((props, ref) => {
    const mappedProps = {};
    if (props.startIcon) {
        mappedProps.endIcon = props.startIcon;
        mappedProps.startIcon = null;
    }
    return (<ButtonV2 {...props} {...mappedProps} ref={ref}/>);
});
Button.displayName = 'Button';
